import { Link } from "react-router-dom";
import { useState } from "react";
import logo from "../images/did_logo1.png";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleDropdown = () => setDropdownOpen(!isDropdownOpen);

  return (
    <header className="bg-gray-900 text-white fixed top-0 left-0 w-full z-40 shadow-lg">
      <nav className="flex justify-between items-center max-w-full mx-auto p-4">
        {/* Logo */}
        <div className="text-xl font-bold">
          <Link
            to="/"
            className="text-white hover:text-yellow-500 transition-all flex items-center"
            onClick={() => window.scrollTo(0, 0)}
          >
            <img
              src={logo}
              alt="DiDRoute Logo"
              className="h-11 w-auto" // Adjust height and width as needed
            />
          </Link>
        </div>

        {/* Hamburger Menu for Mobile */}
        <div className="lg:hidden">
          <button
            onClick={() => setMenuOpen(!isMenuOpen)}
            className="text-white focus:outline-none"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16m-7 6h7"
              ></path>
            </svg>
          </button>
        </div>

        {/* Navigation Links */}
        <div
          className={`${
            isMenuOpen
              ? "absolute top-16 left-0 right-0 bg-gray-900 p-4 shadow-lg"
              : "hidden"
          } lg:relative lg:flex lg:items-center lg:space-x-6 lg:p-0 lg:bg-transparent lg:shadow-none`}
        >
          <Link
            to="/"
            className="text-lg font-medium hover:text-yellow-500 transition-all"
          >
            Home
          </Link>
          <Link
            to="/services"
            className="text-lg font-medium hover:text-yellow-500 transition-all"
          >
            Services
          </Link>

          {/* Products Dropdown */}
          <div className="relative">
            <button
              onClick={toggleDropdown}
              className="text-lg font-medium hover:text-yellow-500 transition-all"
            >
              Products
            </button>
            {isDropdownOpen && (
              <div className="absolute left-0 mt-2 bg-gray-800 p-2 text-white rounded-lg shadow-lg">
                <Link
                  to="/toll-free-number"
                  className="block text-lg hover:text-yellow-500 transition-all px-4 rounded-md hover:bg-gray-700 whitespace-nowrap"
                  onClick={() => setDropdownOpen(false)} // Close dropdown on click
                >
                  Toll Free Number
                </Link>
                <Link
                  to="/did"
                  className="block text-lg hover:text-yellow-500 transition-all px-4 rounded-md hover:bg-gray-700 whitespace-nowrap"
                  onClick={() => setDropdownOpen(false)} // Close dropdown on click
                >
                  DID
                </Link>
                <Link
                  to="/inbound-solution"
                  className="block text-lg hover:text-yellow-500 transition-all px-4 rounded-md hover:bg-gray-700 whitespace-nowrap"
                  onClick={() => setDropdownOpen(false)} // Close dropdown on click
                >
                  Inbound Solution
                </Link>
                <Link
                  to="/outbound-solution"
                  className="block text-lg hover:text-yellow-500 transition-all px-4 py-2 rounded-md hover:bg-gray-700 whitespace-nowrap"
                  onClick={() => setDropdownOpen(false)} // Close dropdown on click
                >
                  Outbound Solution
                </Link>
              </div>
            )}
          </div>

          {/* <Link
            to="/blog"
            className="text-lg font-medium hover:text-yellow-500 transition-all"
          >
            Blog
          </Link> */}
          <Link
            to="/about"
            className="text-lg font-medium hover:text-yellow-500 transition-all"
          >
            About
          </Link>
          <Link
            to="/contact"
            className="text-lg font-medium hover:text-yellow-500 transition-all"
          >
            Contact
          </Link>

          {/* Mobile Login Buttons */}
          <div className="lg:hidden mt-4 flex flex-col space-y-2">
            <Link
              to="/register"
              className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center transition-all duration-300"
              onClick={() => setMenuOpen(false)}
            >
              Sign Up
            </Link>
            <Link
              to="/login"
              className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center transition-all duration-300"
              onClick={() => setMenuOpen(false)}
            >
              Sign In
            </Link>
          </div>
        </div>

        {/* Login Button */}
        <div className="hidden lg:flex gap-x-4">
          <Link
            to="/register"
            className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center transition-all duration-300"
            onClick={(e) => {
              e.preventDefault();
              navigate('/register');
              window.scrollTo(0, 0);
            }}
          >
            Sign Up
          </Link>
          <Link
            to="/login"
            className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center transition-all duration-300"
            onClick={(e) => {
              e.preventDefault();
              navigate('/login');
              window.scrollTo(0, 0);
            }}
          >
            Sign In
          </Link>
        </div>
      </nav>
    </header>
  );
};

export default Header;
